module.exports = __webpack_public_path__ + "assets/img/task_flow_pc.36c79edc.png";